import { s as styleInject } from './style-inject.es-1f59c1d0.js';

var css_248z = ".spring-popup{-ms-flex-align:center;-webkit-align-items:center;align-items:center;display:-webkit-flex;display:-ms-flexbox;display:flex;max-height:91.666667%;padding-left:20px;padding-right:20px;top:25px;z-index:50}.spring-popup,.spring-popup__backdrop{height:100vh;left:0;position:fixed;width:100%}.spring-popup__backdrop{--tw-bg-opacity:1;--tw-bg-opacity:0.7;--tw-backdrop-blur:blur(10px);-webkit-backdrop-filter:var(--tw-backdrop-filter);backdrop-filter:var(--tw-backdrop-filter);background-color:rgba(36,38,33,var(--tw-bg-opacity))}.spring-popup__backdrop,.spring-popup__close{top:0}.spring-popup__close{-ms-flex-align:center;-ms-flex-pack:center;-webkit-align-items:center;align-items:center;cursor:pointer;display:-webkit-flex;display:-ms-flexbox;display:flex;height:40px;-webkit-justify-content:center;justify-content:center;padding:10px;right:0;width:40px}.spring-popup__container{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));margin-left:auto;margin-right:auto;max-height:100%;position:relative;width:100%}@media (max-width:599px){.spring-popup__container--mobile-bottom{border-radius:0;border-top-left-radius:15px;border-top-right-radius:15px;bottom:0;left:0;position:fixed}}";
styleInject(css_248z);

var SpringPopup = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.show ? _c('div', {
      staticClass: "spring-popup"
    }, [_c('div', {
      staticClass: "spring-popup__backdrop",
      on: {
        "click": _vm.backDropClose
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spring-popup__container",
      class: [_vm.containerStyles, _vm.padding, _vm.maxWidth, _vm.borderRadius, _vm.overflowY]
    }, [_vm.closable ? _c('div', {
      staticClass: "spring-popup__close absolute",
      class: _vm.closeColorClass,
      on: {
        "click": function ($event) {
          return _vm.$emit('hide');
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "xmark"
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e();
  },
  staticRenderFns: [],
  // Name
  name: 'SpringPopup',
  // Props
  props: {
    show: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: 'max-w-600 lg:max-w-700'
    },
    borderRadius: {
      type: String,
      default: 'rounded-15'
    },
    mobileBottom: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
      default: 'pt-30 px-15 sm:px-100 py-60'
    },
    closable: {
      type: Boolean,
      default: false
    },
    backDropClosable: {
      type: Boolean,
      default: false
    },
    closeColorClass: {
      type: String,
      default: 'text-black'
    },
    overflowY: {
      type: String,
      default: 'overflow-y-auto'
    }
  },
  // Computed
  computed: {
    containerStyles() {
      return [this.closable ? 'max-h-11/12' : 'max-h-775', this.mobileBottom ? 'spring-popup__container--mobile-bottom' : ''];
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    document.body.scroll = 'no';
  },
  beforeDestroy() {
    document.body.style.overflow = 'visible';
    document.body.scroll = 'yes';
  },
  methods: {
    backDropClose() {
      if (this.backDropClosable) this.$emit('hide');
    }
  }
};

export { SpringPopup as S };
